import { render } from "./SzTableBar.vue?vue&type=template&id=0279122c&scoped=true"
import script from "./SzTableBar.vue?vue&type=script&lang=ts"
export * from "./SzTableBar.vue?vue&type=script&lang=ts"

import "./SzTableBar.vue?vue&type=style&index=0&id=0279122c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0279122c"

export default script